import React from 'react'

function ErrorPageComp() {
    return (
        <div>
            <title>Wrong address</title>
                <h1>Ooops!</h1>
                <h2>I cannot find the file you requested!</h2>
        </div>
    )
}

export default ErrorPageComp
